import i18next from "i18next";
import { onErrorMessage } from "@utils/utilsApi";
import { findExternalTrainingErrorCode } from "./errorCodes";

export const getSkillBookErrorMessage = (error: any): string => {
  const code = findExternalTrainingErrorCode(error);
  return code
    ? String(i18next.getFixedT(null, "skillBook-page")(`api-errors.${code}`))
    : onErrorMessage(error);
};
